import { gql } from '@apollo/client';

export const GET_COURSE = gql`
  query Courses($courseId: Int!) {
    course(courseId: $courseId) {
      id
      name
      canEdit
      SKU
      attendancePercentage
      teachers {
          id
          name
      }
      courseParticipantCount
      tags {
        id
        name
      }
      classRecords {
        id
      }
      sessions {
        id
        course {
            id
            name
            SKU
        }
        durationMinutes
        attendance {
            details
            status
            id
            isTeacher
            user {
                name
                id
                identifier
                photoUrl
            }
        }
        startTime
        attendanceCount
        reasonForCancellation
        attendancePercentage
      }
    }
  }`;
